<template>
  <div class="px-10">
    <div class="text-h4 primary--text mb-5">
      {{ isUpdate ? 'แก้ไขข้อมูล' : 'สร้าง' }} สาขา
    </div>
    <v-alert v-if="loadError" type="error" dense text class="mb-5">
      <div class="d-flex align-center justify-space-between">
        <span>{{ loadError }}</span>
        <v-btn text small color="error" :loading="loading" @click="getData">ลองใหม่</v-btn>
      </div>
    </v-alert>
    <v-row class="pl-15 mb-5">
      <v-col cols="3" class="text-center">
        <uploadImage
          directory="logo"
          :limit="5"
          :max-size="400"
          @uploading="imageUploading = $event"
          :src="form.logo_url"
          @onChangeUrl="form.logo_url = $event"
          buttons
        >
          <template #default="{ open, remove, uploading }">
            <img
              :src="form.logo_url || $defaultImage"
              width="210"
              height="auto"
              :class="{ pointer: form.logo_url }"
              :title="form.logo_url ? 'คลิกเพื่อดูรูปขยาย' : ''"
              @click="viewImage(form.logo_url)"
            />
            <div class="mt-3">
              <v-btn small color="primary" :disabled="uploading" @click="open">
                <v-icon left small>mdi-upload</v-icon>{{ form.logo_url ? 'เปลี่ยนโลโก้' : 'เพิ่มโลโก้' }}
              </v-btn>
              <v-btn v-if="form.logo_url" small outlined color="error" class="ml-2" :disabled="uploading" @click="remove">
                <v-icon left small>mdi-delete</v-icon>ลบ
              </v-btn>
            </div>
            <div class="mt-2 grey--text text--darken-1" style="font-size: 0.9rem">
              JPG, PNG ไม่เกิน 5MB<br />ขนาดแนะนำ 400 x 400 px (พื้นหลังโปร่งใสได้)
            </div>
          </template>
        </uploadImage>
      </v-col>
    </v-row>
    <v-alert v-if="mainSaveError" type="error" dense text class="mx-15 mb-0">
      {{ mainSaveError }}
    </v-alert>
    <v-row>
      <v-col cols class="pl-15 mb-5">
        <!-- <v-text-field
          name="branch_name"
          label="ชื่อสาขา"
          outlined
          dense
          v-model="form.branch_name"
        /> -->
        <v-text-field
          name="store_name"
          label="ชื่อร้าน"
          outlined
          dense
          v-model="form.store_name"
        />
        <v-text-field
          name=""
          label="ชื่อออกใบเสร็จ"
          outlined
          dense
          v-model="form.name_for_receipt"
          :error-messages="$v.form.name_for_receipt.$error ? $error_text : ''"
        />
        <v-text-field
          name="phone_number"
          label="เบอร์ติดต่อ"
          outlined
          dense
          v-model="form.phone_number"
        />

        <v-text-field
          name=""
          label="ที่อยู่ (ไม่จำเป็น)"
          outlined
          dense
          @click="
            (dialogAddressData = form.location),
              (dialogAddress = true),
              (dialogAddressKey = 'location')
          "
          :value="`${form.location.address} ${form.location.sub_district} ${form.location.district} ${form.location.province} ${form.location.postal_code}`"
        />
        <v-text-field
          name=""
          label="เวลาทำการ (ควรใส่)"
          value="คลิกเพื่อเปิดดู"
          outlined
          dense
          @click="
            (dialogBusinessHoursData = form), (dialogBusinessHoursUpdate = true)
          "
        />
        <v-text-field
          name="line_id"
          label="Line ID (ควรใส่)"
          outlined
          dense
          v-model="form.line_id"
        />
        <v-text-field
          name="facebook"
          label="Facebook (ควรใส่)"
          outlined
          dense
          v-model="form.facebook"
        />

        <span class="text-h6 pt-3">บัญชีรับชำระเงิน {{ form.bank_account.length }} บัญชี</span>
        <v-btn
          class="ml-5"
          color="primary"
          small
          outlined
          :disabled="!canEditPayment"
          @click="openBankAccountDialog"
        >
          แก้ไข
        </v-btn>
        <v-alert v-if="!canEditPayment" type="info" dense text class="mt-3">
          เฉพาะเจ้าของร้านเท่านั้นที่แก้ไขบัญชีรับชำระเงินและ QR Code ได้ การตั้งค่าอื่นยังแก้ไขและบันทึกได้ตามปกติ
        </v-alert>
        <v-alert
          v-if="form.setting.qr_code_payment_mode === 'none'"
          type="info"
          dense
          text
          class="mt-5 mb-3"
        >
          จะไม่แสดง QR Code สำหรับรับเงิน
        </v-alert>
        <div :class="['qr-mode-frame', { 'qr-mode-frame--blink': qrNeedsSetup }]" data-test="qr-mode-frame">
        <div ref="qrSetupAnchor" :class="{ 'mt-5': form.setting.qr_code_payment_mode !== 'none' }">
          QR Code สำหรับรับเงิน
        </div>
        <v-col class="py-3">
          <v-select
            v-model="form.setting.qr_code_payment_mode"
            label="วิธีแสดง QR Code"
            outlined
            :items="availableQrCodePaymentModes"
            item-value="value"
            item-text="text"
            dense
            :disabled="!canEditPayment"
            @change="onQrCodePaymentModeChange"
          />

          <template v-if="form.setting.qr_code_payment_mode === 'promptpay'">
            <v-select
              v-model="form.setting.qr_code_payment_account_id"
              label="บัญชี PromptPay สำหรับสร้าง QR"
              outlined
              dense
              :items="promptPayAccounts"
              item-value="_id"
              item-text="display_name"
              :disabled="!canEditPayment"
              :error-messages="qrCodePaymentAccountError"
            />
            <v-alert v-if="promptPayAccounts.length === 0" type="warning" dense text>
              ยังไม่มีบัญชี PromptPay
              <v-btn v-if="canEditPayment" text small color="warning" @click="openBankAccountDialog">เพิ่มบัญชี PromptPay กดที่นี่</v-btn>
            </v-alert>
            <v-alert v-else-if="qrCodePaymentAccountError" type="warning" dense text>
              {{ qrCodePaymentAccountError }}
            </v-alert>
            <div class="grey--text text--darken-1 mb-5">
              ระบบจะใช้บัญชีที่เลือกเมื่อมีการสร้าง PromptPay QR ใน Phase ถัดไป
            </div>
          </template>

          <template v-else-if="form.setting.qr_code_payment_mode === 'image'">
            <uploadImage
              directory="qr_code_pay"
              :limit="5"
              :max-size="600"
              @uploading="imageUploading = $event"
              :src="form.qr_code_payment"
              @onChangeUrl="form.qr_code_payment = $event"
              buttons
            >
              <template #default="{ open, remove, uploading }">
                <img
                  :src="form.qr_code_payment || $defaultImage"
                  width="150"
                  :style="{ height: form.qr_code_payment ? 'auto' : '150px' }"
                  :class="{ pointer: form.qr_code_payment }"
                  :title="form.qr_code_payment ? 'คลิกเพื่อดูรูปขยาย' : ''"
                  @click="viewImage(form.qr_code_payment)"
                />
                <div class="mt-2">
                  <v-btn small color="primary" :disabled="uploading || !canEditPayment" @click="open">
                    <v-icon left small>mdi-upload</v-icon>{{ form.qr_code_payment ? 'เปลี่ยน QR Code' : 'เพิ่ม QR Code' }}
                  </v-btn>
                  <v-btn v-if="form.qr_code_payment" small outlined color="error" class="ml-2" :disabled="uploading || !canEditPayment" @click="remove">
                    <v-icon left small>mdi-delete</v-icon>ลบ
                  </v-btn>
                </div>
                <div class="mt-2 mb-5 grey--text text--darken-1" style="font-size: 0.9rem">
                  JPG, PNG ไม่เกิน 5MB<br />ขนาดแนะนำ 600 x 600 px (รูปสี่เหลี่ยมจัตุรัส)
                </div>
              </template>
            </uploadImage>
          </template>

          <template v-else-if="form.setting.qr_code_payment_mode === 'template'">
            <v-text-field
              v-model="form.setting.qr_code_payment_template_label"
              label="ข้อความแสดงใต้ QR (ไม่บังคับ)"
              hint="แสดงที่จอลูกค้าและในใบพิมพ์ เพื่อให้ลูกค้ารู้ว่าโอนให้ใคร เช่น ชื่อร้านหรือชื่อบัญชีที่รับเงิน"
              persistent-hint
              counter="80"
              maxlength="80"
              outlined
              dense
              class="mb-3"
              :disabled="!canEditPayment"
              data-test="qr-template-label"
            />

            <template v-if="form.setting.qr_code_payment_template_id">
              <v-alert type="success" dense text data-test="qr-template-active">
                ตั้งค่า QR ร้านค้าแล้ว ระบบจะใส่ยอดเงินของแต่ละบิลให้อัตโนมัติ
              </v-alert>
              <v-btn
                color="primary"
                outlined
                small
                class="mb-5"
                :disabled="!canEditPayment || loading"
                data-test="qr-template-open"
                @click="qrTemplateDialog = true"
              >
                เปลี่ยน QR Code
              </v-btn>
            </template>
            <v-alert v-else type="warning" text prominent data-test="qr-template-missing">
              <div class="d-flex flex-column flex-sm-row align-sm-center">
                <div class="flex-grow-1 mb-3 mb-sm-0">
                  <b>ยังไม่ได้ตั้งค่า QR ร้านค้า</b><br />
                  อัปโหลดรูป QR ของร้านจากแอปร้านค้า แล้วทดสอบโอน 1 บาท ระบบจึงจะเริ่มใช้งาน
                </div>
                <div class="d-flex flex-column flex-sm-row align-center">
                  <template v-if="canEditPayment">
                    <v-icon large color="orange darken-3" class="qr-template-arrow qr-template-arrow--right d-none d-sm-inline-flex" data-test="qr-template-arrow">mdi-arrow-right-bold</v-icon>
                    <v-icon large color="orange darken-3" class="qr-template-arrow qr-template-arrow--down d-sm-none">mdi-arrow-down-bold</v-icon>
                  </template>
                  <v-btn
                    color="primary"
                    large
                    depressed
                    class="ml-sm-2"
                    :disabled="!canEditPayment || loading"
                    data-test="qr-template-open"
                    @click="qrTemplateDialog = true"
                  >
                    <v-icon left>mdi-qrcode-scan</v-icon>
                    ตั้งค่า QR Code
                  </v-btn>
                </div>
              </div>
            </v-alert>
          </template>

          <template v-if="form.setting.qr_code_payment_mode !== 'none'">
          <v-select
            v-model="form.setting.show_qr_code_payment"
            label="แสดง QR Code ชำระเงินที่ (พิมพ์ / จอลูกค้า)"
            outlined
            :items="list.scrap"
            item-value="value"
            item-text="name"
            dense
            class="pt-2"
          ></v-select>
          <div
            v-if="form.setting.qr_code_payment_mode === 'template' && templatePreviewImage"
            class="text-center mb-4"
            data-test="qr-template-preview-box"
          >
            <img :src="templatePreviewImage" width="180" height="180" alt="QR ร้านค้าที่ใช้อยู่" data-test="qr-template-preview" />
            <div class="grey--text text--darken-1" style="font-size: 0.9rem">
              QR ร้านค้าที่ใช้อยู่ (ตัวอย่างแบบไม่ระบุยอดเงิน) เมื่อออกบิล ระบบจะใส่ยอดเงินให้อัตโนมัติ
            </div>
          </div>
          </template>
        </v-col>
        </div>
      </v-col>

      <v-col cols offset="1">
        <div class="mb-5">ตำแหน่งที่ตั้ง (ไม่จำเป็น)</div>
        <v-col>
          <v-row>
            <v-text-field
              name="lat"
              label="ละติจูด"
              outlined
              dense
              v-model="form.geopoint.lat"
            />
            &nbsp; &nbsp;
            <v-text-field
              name="lng"
              label="ลองจิจูด"
              outlined
              dense
              v-model="form.geopoint.lng"
            />
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <div class="mt-1">เป็นนิติบุคคล ?</div>

            <v-radio-group class="mt-0 ml-10" row v-model="legalEntity1">
              <v-radio name="" label="เป็น" :value="true"></v-radio>
              <!-- <v-spacer /> -->
              <v-radio name="" label="ไม่เป็น" :value="false"></v-radio>
            </v-radio-group>
          </v-row>
        </v-col>
        <div v-if="legalEntity1">
          <v-text-field
            name="company_branch"
            label="สาขาบริษัท"
            outlined
            dense
            v-model="form.company_branch"
          />
          <v-text-field
            name="taxpayer_number"
            label="เลขประจำตัวผู้เสียภาษี"
            outlined
            dense
            v-model="form.taxpayer_number"
            :error-messages="$v.form.taxpayer_number.$error ? $error_text : ''"
          />
          <v-text-field
            name="email"
            label="E - mail"
            outlined
            dense
            v-model="form.email"
            :error-messages="$v.form.email.$error ? $error_text : ''"
          />
        </div>

        <v-col>
          <v-row>
            <div class="mt-1">
              ภาษีมูลค่าเพิ่ม (กรุณาตั้งค่าให้เรียบร้อย ก่อนใช้งาน)
            </div>
            <v-radio-group
              class="mt-0 ml-10"
              row
              v-model="form.vat_registration"
            >
              <v-radio name="" label="จดภาษี" :value="true"></v-radio>
              <!-- <v-spacer /> -->
              <v-radio name="" label="ไม่จดภาษี" :value="false"></v-radio>
            </v-radio-group>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <div class="mt-1">แยกสินค้าบางอัน ไปบิลอีกใบนึง</div>
            <v-radio-group class="mt-0 ml-10" row v-model="form.is_split_bill">
              <v-radio name="" label="เปิดใช้งาน" :value="true" />
              <!-- <v-spacer /> -->
              <v-radio name="" label="ปิดใช้งาน" :value="false" />
            </v-radio-group>
          </v-row>
        </v-col>

        <v-col>
          <v-select
            v-model="form.setting.service_rating_mode"
            label="การประเมินการบริการ"
            outlined
            dense
            :items="serviceRatingModes"
            item-value="value"
            item-text="text"
            data-test="service-rating-mode"
          />
          <v-btn
            v-if="form.setting.service_rating_mode === 'customer_display'"
            color="primary"
            outlined
            small
            data-test="service-rating-configure"
            @click="serviceRatingDialog = true"
          >
            ตั้งค่าข้อความหลังประเมิน
          </v-btn>
        </v-col>
      </v-col>
    </v-row>

    <v-divider class="mb-10" v-if="form.is_split_bill" />

    <div class="text-h4 primary--text mb-5" v-if="form.is_split_bill">
      {{ isUpdate ? 'แก้ไข' : 'สร้าง' }}ตั้งค่าบริษัทที่จะแยกบิล
    </div>
    <v-row class="pl-15 mb-5" v-if="form.is_split_bill">
      <v-col cols="3" class="text-center">
        <uploadImage
          directory="logo"
          :limit="5"
          :max-size="400"
          @uploading="imageUploading = $event"
          :src="form.split_bill_data.logo_url"
          @onChangeUrl="form.split_bill_data.logo_url = $event"
          buttons
        >
          <template #default="{ open, remove, uploading }">
            <img
              :src="form.split_bill_data.logo_url || $defaultImage"
              width="210"
              height="auto"
              :class="{ pointer: form.split_bill_data.logo_url }"
              :title="form.split_bill_data.logo_url ? 'คลิกเพื่อดูรูปขยาย' : ''"
              @click="viewImage(form.split_bill_data.logo_url)"
            />
            <div class="mt-3">
              <v-btn small color="primary" :disabled="uploading" @click="open">
                <v-icon left small>mdi-upload</v-icon>{{ form.split_bill_data.logo_url ? 'เปลี่ยนโลโก้' : 'เพิ่มโลโก้' }}
              </v-btn>
              <v-btn v-if="form.split_bill_data.logo_url" small outlined color="error" class="ml-2" :disabled="uploading" @click="remove">
                <v-icon left small>mdi-delete</v-icon>ลบ
              </v-btn>
            </div>
            <div class="mt-2 grey--text text--darken-1" style="font-size: 0.9rem">
              JPG, PNG ไม่เกิน 5MB<br />ขนาดแนะนำ 400 x 400 px (พื้นหลังโปร่งใสได้)
            </div>
          </template>
        </uploadImage>
      </v-col>
    </v-row>
    <v-row v-if="form.is_split_bill">
      <v-col cols class="pl-15">
        <v-text-field
          name="split_bill_data_name"
          label="ชื่อร้านที่จะแสดงบนหัวใบเสร็จ"
          outlined
          dense
          v-model="form.split_bill_data.name"
          :rules="[() => !!form.split_bill_data.name || 'กรุณากรอกข้อมูล']"
          required
        />
        <v-text-field
          name="split_bill_data_phone_number"
          label="เบอร์ติดต่อ"
          outlined
          dense
          v-model="form.split_bill_data.phone_number"
          :rules="[
            () => !!form.split_bill_data.phone_number || 'กรุณากรอกข้อมูล',
          ]"
          required
        />
        <v-col>
          <v-row>
            <div class="mt-1">ใช้ที่อยู่เดียวกับด้านบน</div>
            <v-radio-group
              class="mt-0 ml-10"
              row
              v-model="form.split_bill_data.is_same_as_above"
              @change="
                (val) => {
                  if (val) form.split_bill_data.location = { ...form.location };
                }
              "
            >
              <v-radio name="" label="ใช่" :value="true"></v-radio>
              <!-- <v-spacer /> -->
              <v-radio name="" label="ไม่ใช่" :value="false"></v-radio>
            </v-radio-group>
          </v-row>
        </v-col>
        <v-text-field
          name="split_bill_data_address"
          label="ที่อยู่"
          outlined
          dense
          :disabled="form.split_bill_data.is_same_as_above"
          @click="
            (dialogAddressData = form.split_bill_data.location),
              (dialogAddress = true),
              (dialogAddressKey = 'split_bill_data.location')
          "
          :value="`${form.split_bill_data.location.address} ${form.split_bill_data.location.sub_district} ${form.split_bill_data.location.district} ${form.split_bill_data.location.province} ${form.split_bill_data.location.postal_code}`"
        />
        <!-- v-model="form.split_bill_data.location" -->

        <v-text-field
          name="split_bill_data_line_id"
          label="Line ID (ควรใส่)"
          outlined
          dense
          v-model="form.split_bill_data.line_id"
        />
        <v-text-field
          name="split_bill_data_facebook"
          label="Facebook (ควรใส่)"
          outlined
          dense
          v-model="form.split_bill_data.facebook"
        />
      </v-col>
      <v-col cols offset="1">
        <v-select
          v-model="form.split_bill_category"
          :items="categories"
          item-value="_id"
          :item-text="(item) => `${item.name} ${item.broker}`"
          chips
          small-chips
          label="หมวดหมู่ย่อยสินค้าที่ออกบิลนี้"
          multiple
          dense
          outlined
          :rules="[
            () => form.split_bill_category.length >= 1 || 'กรุณากรอกข้อมูล',
          ]"
          required
        ></v-select>
        <v-col>
          <v-row>
            <div class="mt-1">เป็นนิติบุคคล ?</div>

            <v-radio-group class="mt-0 ml-10" row v-model="legalEntity2">
              <v-radio name="" label="เป็น" :value="true"></v-radio>
              <!-- <v-spacer /> -->
              <v-radio name="" label="ไม่เป็น" :value="false"></v-radio>
            </v-radio-group>
          </v-row>
        </v-col>
        <div v-if="legalEntity2">
          <v-text-field
            name="split_bill_data_company_branch"
            label="สาขาบริษัท"
            outlined
            dense
            v-model="form.split_bill_data.company_branch"
          />
          <v-text-field
            name="split_bill_data_taxpayer_number"
            label="เลขประจำตัวผู้เสียภาษี"
            outlined
            dense
            v-model="form.split_bill_data.taxpayer_number"
            :error-messages="
              $v.form.split_bill_data.taxpayer_number.$error ? $error_text : ''
            "
          />
          <v-text-field
            name="split_bill_data_email"
            label="E - mail"
            outlined
            dense
            v-model="form.split_bill_data.email"
          />
        </div>
        <v-col>
          <v-row>
            <div class="mt-1">ภาษีมูลค่าเพิ่ม</div>
            <v-radio-group
              class="mt-0 ml-10"
              row
              v-model="form.split_bill_data.vat_registration"
            >
              <v-radio name="" label="จดภาษี" :value="true"></v-radio>
              <!-- <v-spacer /> -->
              <v-radio name="" label="ไม่จดภาษี" :value="false"></v-radio>
            </v-radio-group>
          </v-row>
        </v-col>
        <v-col>
          <v-row>
            <div class="mt-1">
              ปริ้นใบเสร็จ หน้า-หลัง
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" small v-bind="attrs" v-on="on"
                    >mdi-information</v-icon
                  >
                </template>
                <span>เปิดใช้งานนี้ เพื่อพิมพ์ใบเสร็จแบบ 1 แผ่น หน้าหลัง</span>
              </v-tooltip>
            </div>
            <v-radio-group
              class="mt-0 ml-10"
              row
              v-model="form.setting.print_one_page"
            >
              <v-radio name="" label="หน้าเดียว" :value="false"></v-radio>
              <!-- <v-spacer /> -->
              <v-radio name="" label="หน้าหลัง" :value="true"></v-radio>
            </v-radio-group>
          </v-row>
        </v-col>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-right pb-10">
        <v-btn class="px-10 mr-15" color="grey" outlined @click="close()">
          ปิด
        </v-btn>
        <v-btn
          class="px-10"
          color="primary"
          @click="save()"
          :loading="loading"
          :disabled="loading || imageUploading || !!loadError"
        >
          บันทึกข้อมูล
        </v-btn>
      </v-col>
    </v-row>

    <!-- Owners who have no QR yet: a pointer that leads down to the QR settings, gone once they are in view. -->
    <transition name="qr-pointer-fade">
      <v-btn
        v-if="qrPointerVisible"
        fab
        depressed
        color="orange darken-2"
        dark
        class="qr-setup-pointer"
        aria-label="ไปที่การตั้งค่า QR Code"
        data-test="qr-setup-pointer"
        @click="scrollToQrSetup"
      >
        <span class="qr-setup-pointer__inner">
          <span class="qr-setup-pointer__text">ตั้งค่า QR Code</span>
          <v-icon large class="qr-setup-pointer__arrow">mdi-arrow-down-bold</v-icon>
        </span>
      </v-btn>
    </transition>

    <v-dialog v-if="isUpdate" persistent scrollable max-width="720" v-model="qrTemplateDialog">
      <QrTemplateDialog
        v-if="qrTemplateDialog"
        :branch-id="String(form._id || $route.params.id)"
        :initial-label="form.setting.qr_code_payment_template_label || ''"
        @onClose="qrTemplateDialog = false"
        @onActivated="onQrTemplateActivated"
      />
    </v-dialog>

    <v-dialog persistent scrollable max-width="900" v-model="serviceRatingDialog">
      <ServiceRatingDialog
        v-if="serviceRatingDialog"
        :item="form.setting"
        @onClose="serviceRatingDialog = false"
        @onApply="onServiceRatingApply"
        @onUploading="imageUploading = $event"
      />
    </v-dialog>

    <v-dialog persistent scrollable width="2000" height="1200" max-width="85%" v-model="dialogUpdate">
      <BankAccount
        :key="bankAccountDialogKey"
        :item="form.bank_account"
        :delete_bank_account="form.delete_bank_account"
        save-with-parent
        :saving="loading"
        :submit-error="bankAccountSaveError"
        @onClose="closeBankAccountDialog"
        @onSubmit="saveBankAccounts"
      />
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      max-width="1200"
      v-model="dialogBusinessHoursUpdate"
    >
      <BusinessHours
        :item="form.open_hours"
        @onClose="dialogBusinessHoursUpdate = false"
        @onChange="(val) => (form.open_hours = val)"
      />
    </v-dialog>

    <v-dialog v-model="imagePreviewDialog" max-width="720">
      <v-card>
        <v-card-text class="text-center pa-4" style="background: #f0f0f0">
          <img
            :src="imagePreviewSrc"
            alt=""
            style="max-width: 100%; max-height: 75vh; object-fit: contain"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text color="primary" @click="imagePreviewDialog = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent scrollable max-width="1800" v-model="dialogAddress">
      <AddressDetail
        :item="dialogAddressData"
        @onClose="dialogAddress = false"
        @onSubmit="onSubmitAddress"
      />
    </v-dialog>
  </div>
</template>

<script>
import BankAccount from '@/views/pages/setting/business-branch/BankAccount.vue';
import QrTemplateDialog from '@/views/pages/setting/business-branch/QrTemplateDialog.vue';
import QRCode from 'qrcode';
import BusinessHours from '@/views/pages/setting/business-branch/BusinessHours.vue';
import {
  required,
  checked,
  email,
  maxLength,
  minLength,
  numeric,
  requiredIf,
} from 'vuelidate/lib/validators';
import AddressDetail from './AddressDetail.vue';
import uploadImage from '@/components/uploadImage.vue';
import ServiceRatingDialog from './ServiceRatingDialog.vue';

export default {
  components: {
    BankAccount,
    QrTemplateDialog,
    BusinessHours,
    AddressDetail,
    uploadImage,
    ServiceRatingDialog,
  },
  data: () => ({

    legalEntity1: false,
    legalEntity2: false,
    form: {
      branch_id: 0,
      bank_account: [],
      branch_name: '',
      company_branch: '',
      // company_group_id: "",
      document_setting: {
        credit_note: { header: '', note: '' },
        debit_note: { header: '', note: '' },
        invoice: { header: '', note: '' },
        quotation: { header: '', note: '' },
        receipt: { header: '', note: '' },
        tax_invoice: { header: '', note: '' },
      },
      email: '',
      facebook: '',
      geopoint: { lat: '', lng: '' },
      is_split_bill: false,
      line_id: '',
      location: {
        address: '',
        district: '',
        postal_code: '',
        province: '',
        sub_district: '',
      },
      logo_url: '',
      qr_code_payment: '',
      name_for_receipt: '',
      open_hours: {
        friday: { open: false, time: [{ end: '', start: '' }] },
        monday: { open: false, time: [{ end: '', start: '' }] },
        saturday: { open: false, time: [{ end: '', start: '' }] },
        sunday: { open: false, time: [{ end: '', start: '' }] },
        thursday: { open: false, time: [{ end: '', start: '' }] },
        tuesday: { open: false, time: [{ end: '', start: '' }] },
        wednesday: { open: false, time: [{ end: '', start: '' }] },
      },
      phone_number: '',
      setting: {
        print_one_page: '',
        enable_product_merging: false,
        receipt_printing_format: 0,
        domain_for_qr: '',
        alert_onselect_cartype2: '',
        ban_car_province: [],
        car_tax_scrap: 0,
        cost_extension_car_tax: 0,
        cost_extension_motorbike_tax: 0,
        document_pickup_date: 0,
        document_pickup_time: '',
        merging_subcategory: [],
        ges_inspect_alert: false,
        letter_alert: false,
        reduce_bill_scrap: false,
        sms_alert: false,
        starting_province: '',
        tel_alert: false,
        third_insurance_tax_scrap: 0,
        CT1_3rdinsurance_express: '',
        CT2_3rdinsurance_express: '',
        CT3_3rdinsurance_express: '',
        CT4_3rdinsurance_express: '',
        other_3rdinsurance_express: '',
        qr_tracking: false,
        domain_for_qr: '',
        show_qr_code_payment: '',
        qr_code_payment_mode: 'none',
        qr_code_payment_account_id: '',
        qr_code_payment_template_id: '',
        qr_code_payment_template_label: '',
        service_rating_mode: 'off',
        service_rating_thank_you_title: '',
        service_rating_thank_you_content: '',
        service_rating_thank_you_image_url: '',
        service_rating_display_seconds: 60,
      },
      split_bill_category: [],
      split_bill_data: {
        company_branch: '',
        email: '',
        facebook: '',
        line_id: '',
        location: {
          address: '',
          district: '',
          postal_code: '',
          province: '',
          sub_district: '',
        },
        logo_url: '',
        name: '',
        taxpayer_number: '',
        phone_number: '',
        vat_registration: false,
        is_same_as_above: false,
      },
      store_name: '',
      taxpayer_number: '',
      vat_registration: false,
    },

    dialogUpdate: false,
    qrTemplateDialog: false,
    serviceRatingDialog: false,
    // Ownership of the Service Rating thank-you image, once Apply has merged
    // it into form.setting: savedServiceRatingImageUrl is the URL the backend
    // last actually confirmed (set in getData() and right after a successful
    // save); pendingServiceRatingUpload is non-'' only while form.setting's
    // current image differs from that confirmed baseline - i.e. applied but
    // not yet (successfully) saved, and therefore still eligible for cleanup
    // if the page is left or the save fails.
    savedServiceRatingImageUrl: '',
    pendingServiceRatingUpload: '',
    qrAnchorInView: true,
    templatePreviewImage: '',
    templatePreviewRequest: 0,
    bankAccountDialogKey: 0,
    bankAccountSaveError: '',
    loadError: '',
    mainSaveError: '',
    dialogBusinessHoursUpdate: false,
    dialogBusinessHoursData: null,
    dialogAddressKey: '',
    dialogAddress: false,
    dialogAddressData: {
      address: '',
      district: '',
      postal_code: '',
      province: '',
      sub_district: '',
    },

    selected: [],
    loading: false,
    imageUploading: false,
    imagePreviewDialog: false,
    imagePreviewSrc: '',
    categories: [],
    valid: true,
    rules: {
      required: (v) => !!v || 'this field is required',
    },
    qrCodePaymentModes: [
      { value: 'promptpay', text: 'สร้าง QR PromptPay และจำนวนเงินอัตโนมัติ' },
      { value: 'image', text: 'ใช้รูป QR ที่อัปโหลดเอง' },
      { value: 'template', text: 'ใช้ QR code ร้านค้า เช่น แม่มณี, K shop, ถุงเงิน, True Wallet เป็นต้น + จำนวนเงินอัตโนมัติ' },
      { value: 'none', text: 'ไม่ใช้ QR Code' },
    ],
    serviceRatingModes: [
      { value: 'off', text: 'ปิด' },
      { value: 'customer_display', text: 'เปิดใช้งานผ่านจอลูกค้า' },
    ],
    list: {
      scrap: [
        {
          value: 0,
          name: 'พิมพ์เท่านั้น: ใบเสนอราคา, ใบแจ้งหนี้',
        },
        {
          value: 1,
          name: 'พิมพ์เท่านั้น: ใบเสนอราคา, ใบแจ้งหนี้, ใบเสร็จ',
        },
        {
          value: 2,
          name: 'จอลูกค้าเท่านั้น (ไม่พิมพ์ QR บนเอกสาร): ใบเสนอราคา, ใบแจ้งหนี้, ใบเสร็จ',
        },
        {
          value: 3,
          name: 'พิมพ์ + จอลูกค้า: ใบเสนอราคา, ใบแจ้งหนี้',
        },
        {
          value: 4,
          name: 'พิมพ์ + จอลูกค้า: ใบเสนอราคา, ใบแจ้งหนี้, ใบเสร็จ',
        },
      ],
    }
  }),
  validations: function () {
    return {
      form: {
        // branch_name: { required },
        // store_name: { required },
        email: { email },
        name_for_receipt: { required },
        taxpayer_number: {
          numeric,
          //minLength: minLength(13),
          //maxLength: maxLength(13),
        },
        // split_bill_category: {
        //   required,
        // },
        split_bill_data: {
          // phone_number: {
          //   required: requiredIf(function () {
          //     return this.form.is_split_bill;
          //   }),
          // },
          // company_branch: {
          //   required: requiredIf(function() {
          //     return this.form.is_split_bill;
          //   })
          // },
          // email: {
          //   email: requiredIf(function() {
          //     return this.form.is_split_bill;
          //   })
          // },
          // location: {
          //   address: {
          //     required: requiredIf(function() {
          //       return this.form.is_split_bill;
          //     })
          //   },
          //   district: {
          //     required: requiredIf(function() {
          //       return this.form.is_split_bill;
          //     })
          //   },
          //   postal_code: {
          //     required: requiredIf(function() {
          //       return this.form.is_split_bill;
          //     })
          //   },
          //   province: {
          //     required: requiredIf(function() {
          //       return this.form.is_split_bill;
          //     })
          //   },
          //   sub_district: {
          //     required: requiredIf(function() {
          //       return this.form.is_split_bill;
          //     })
          //   }
          // },
          // name: {
          //   required: requiredIf(function () {
          //     return this.form.is_split_bill;
          //   }),
          // },
          taxpayer_number: {
            numeric,
            //minLength: minLength(13),
            //maxLength: maxLength(13),
          },
        },
      },
    };
  },
  mounted() {
    // capture: the page may scroll inside a Vuetify container rather than the window
    window.addEventListener('scroll', this.updateQrAnchorInView, true);
    window.addEventListener('resize', this.updateQrAnchorInView);
    this.updateQrAnchorInView();
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateQrAnchorInView, true);
    window.removeEventListener('resize', this.updateQrAnchorInView);
    // Applying the Service Rating dialog is not the same as saving the branch:
    // if the user leaves this page with an applied-but-never-successfully-saved
    // upload still pending, it was never referenced by any saved branch and
    // must not be left orphaned.
    if (this.pendingServiceRatingUpload) {
      this.deleteUnsavedServiceRatingImage(this.pendingServiceRatingUpload);
    }
  },
  updated() {
    // the payment section appears only after the branch has loaded
    this.updateQrAnchorInView();
  },
  created() {
    this.loadOwnerFlag();
    this.getCategory();
    if (this.isUpdate) this.getData();
    if (this.$route.query.dialogUpdate == true) {
      this.dialogUpdate = this.$route.query.dialogUpdate;
      this.$route.query.dialogUpdate = false;
    }
  },
  methods: {
    updateQrAnchorInView() {
      const anchor = this.$refs.qrSetupAnchor;
      // "in view" = the heading of the payment section is on screen, above the bottom edge
      this.qrAnchorInView = !anchor || anchor.getBoundingClientRect().top < window.innerHeight - 40;
    },
    scrollToQrSetup() {
      const anchor = this.$refs.qrSetupAnchor;
      if (anchor && anchor.scrollIntoView) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    // group_tag comes from user_group/get_by_id; unknown or failed => not owner.
    async loadOwnerFlag() {
      await this.$store.dispatch('getGroupPermissions');
    },
    viewImage(url) {
      if (!url) return;
      this.imagePreviewSrc = url;
      this.imagePreviewDialog = true;
    },
    getCategory() {
      let body = {
        token: this.$jwt.sign(
          { branch_id: this.$store.state.selected_branch._id },
          this.$privateKey,
          { noTimestamp: true }
        ),
      };
      this.$axios
        .post(`${this.$baseUrl}/sub_category/get_sub_category`, body)
        .then(async (res) => {
          this.categories = res.result;
        });
    },
    getData() {
      this.loading = true;
      this.loadError = '';
      let body = {
        token: this.$jwt.sign(
          { branch_id: this.$route.params.id },
          this.$privateKey,
          { noTimestamp: true }
        ),
      };
      return this.$axios
        .post(`${this.$baseUrl}/branch/get_by_id`, body)
        .then(async (res) => {
          this.form = { ...res.result };
          this.ensureQrCodePaymentSettings();
          this.ensureServiceRatingSettings();
          // Whatever the backend just confirmed is the new baseline: nothing
          // applied since is "pending" relative to a load that just happened.
          this.savedServiceRatingImageUrl = this.form.setting.service_rating_thank_you_image_url;
          this.pendingServiceRatingUpload = '';
          if (this.form.taxpayer_number) {
            this.legalEntity1 = true;
          }
          if (this.form.split_bill_data.taxpayer_number) {
            this.legalEntity2 = true;
          }
          this.form.delete_bank_account = [];
        })
        .catch((err) => {
          this.loadError = err.error_message || 'ไม่สามารถโหลดข้อมูลสาขาได้';
        })
        .then(() => {
          this.loading = false;
        });
    },
    async save({ skipConfirmation = false, refreshAfterSave = true } = {}) {
      if (this.imageUploading) {
        const uploadingError = 'กำลังอัปโหลดรูป กรุณารอสักครู่แล้วบันทึกอีกครั้ง';
        if (!skipConfirmation) this.mainSaveError = uploadingError;
        return { success: false, error: uploadingError };
      }
      if (!skipConfirmation) this.mainSaveError = '';
      this.ensureQrCodePaymentSettings();
      this.ensureServiceRatingSettings();
      const qrCodePaymentError = this.getQrCodePaymentSettingError();
      if (qrCodePaymentError) {
        if (!skipConfirmation) this.mainSaveError = qrCodePaymentError;
        return { success: false, error: qrCodePaymentError };
      }

      // Trigger form validation
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        const validationError = 'กรุณากรอกข้อมูลสาขาที่จำเป็นให้ครบถ้วนก่อนบันทึก';
        if (!skipConfirmation) this.mainSaveError = validationError;
        return {
          success: false,
          error: validationError,
        };
      }

      // Show confirmation prompt
      try {
        if (!skipConfirmation) {
          const result = await this.$alertConfirm({ title: 'ยืนยันบันทึกข้อมูล ?', text: '' });
          if (!result.isConfirmed) return { success: false, cancelled: true };
        }

        // Set branch_name from store_name
        this.form.branch_name = this.form.store_name;

        // Prepare form data
        const subPath = this.isUpdate ? 'edit_branch' : 'create_branch';
        let formData = { ...this.form };
        if (this.isUpdate) {
          formData = { branch_id: this.form._id, ...formData };
          delete formData._id;
        }

        // Create request body with signed JWT token
        const body = {
          token: this.$jwt.sign(formData, this.$privateKey, { noTimestamp: true }),
        };

        // Set loading state
        this.loading = true;

        // Send request
        const response = await this.$axios.post(`${this.$baseUrl}/branch/${subPath}`, body);

        // Show success alert and redirect if needed
        this.$alertSuccess({ title: response.status });
        // The branch save genuinely succeeded: whatever Service Rating image
        // was applied is now the real baseline, not a pending/unsaved upload
        // anymore (covers the create-branch redirect below too, which never
        // calls refreshAfterSave()/getData()).
        this.savedServiceRatingImageUrl = this.form.setting.service_rating_thank_you_image_url;
        this.pendingServiceRatingUpload = '';
        if (!this.isUpdate) {
          this.$router.push({ name: 'setting-business-branch' });
        } else if (refreshAfterSave) {
          await this.refreshAfterSave();
        }
        return { success: true };
      } catch (err) {
        console.error('Error saving data:', err);
        this.$alertServerError({ title: err.error_message || 'Server Error' });
        return {
          success: false,
          error: err.error_message || 'ไม่สามารถบันทึกข้อมูลสาขาได้',
        };
      } finally {
        this.loading = false;
      }
    },
    // Replaces the old location.reload(): re-read the saved branch and sync the store
    // so other pages (branch list, selected branch, print/QR settings) see the new data.
    async refreshAfterSave() {
      await this.getData();
      if (this.loadError) return;
      this.$store.commit('updateBranch', this.form);
      if (this.$store.state.selected_branch._id === this.form._id) {
        this.$store.commit('setSelectedBranch', this.form._id);
      }
    },
    close() {
      this.$router.push({ name: 'setting-business-branch' });
    },
    onChangeBankAccount(bankAccount, deleteList) {
      this.form.bank_account = bankAccount;
      if (this.isUpdate) this.form.delete_bank_account = deleteList;
      this.ensurePromptPayAccountSelection();
    },
    openBankAccountDialog() {
      this.bankAccountSaveError = '';
      this.dialogUpdate = true;
    },
    closeBankAccountDialog() {
      if (this.loading) return;
      this.bankAccountSaveError = '';
      this.dialogUpdate = false;
      this.bankAccountDialogKey += 1;
    },
    async saveBankAccounts(bankAccount, deleteList) {
      this.bankAccountSaveError = '';
      const selectedPromptPayAccountId = this.form.setting.qr_code_payment_account_id;
      const isRemovingSelectedPromptPayAccount = (
        this.form.setting.qr_code_payment_mode === 'promptpay'
        && selectedPromptPayAccountId
        && !(bankAccount || []).some(
          (account) => account._id === selectedPromptPayAccountId
        )
      );

      if (isRemovingSelectedPromptPayAccount) {
        this.bankAccountSaveError = 'บัญชีนี้กำลังใช้สำหรับ QR PromptPay จึงยังลบไม่ได้ กรุณาเลือกบัญชี PromptPay ใหม่ หรือเปลี่ยนเป็น “ไม่ใช้ QR Code” ก่อน';
        return;
      }

      this.onChangeBankAccount(bankAccount, deleteList);

      const saveResult = await this.save({
        skipConfirmation: true,
        refreshAfterSave: false,
      });
      if (saveResult && saveResult.success) {
        this.dialogUpdate = false;
        await this.refreshAfterSave();
        return;
      }

      this.bankAccountSaveError = (saveResult && saveResult.error)
        || 'ไม่สามารถบันทึกข้อมูลสาขาได้';
    },
    ensureQrCodePaymentSettings() {
      if (!this.form.setting) this.$set(this.form, 'setting', {});
      const setting = this.form.setting;
      const mode = String(setting.qr_code_payment_mode || '').toLowerCase();
      if (!['promptpay', 'image', 'template', 'none'].includes(mode)) {
        this.$set(
          setting,
          'qr_code_payment_mode',
          this.form.qr_code_payment ? 'image' : 'none'
        );
      }
      if (typeof setting.qr_code_payment_account_id !== 'string') {
        this.$set(setting, 'qr_code_payment_account_id', '');
      }
      if (typeof setting.qr_code_payment_template_id !== 'string') {
        this.$set(setting, 'qr_code_payment_template_id', '');
      }
      if (typeof setting.qr_code_payment_template_label !== 'string') {
        this.$set(setting, 'qr_code_payment_template_label', '');
      }
      this.ensurePromptPayAccountSelection();
    },
    // Missing/invalid service_rating_mode (branch predates this feature, or an
    // old client omitted it) must behave as 'off', mirroring the backend's own
    // setdefault default (Branch.get_setting()). Always writes back the
    // canonical value, even when the stored one was already valid, so the
    // form never carries a stray-cased/whitespace variant into save().
    ensureServiceRatingSettings() {
      if (!this.form.setting) this.$set(this.form, 'setting', {});
      const setting = this.form.setting;
      const mode = String(setting.service_rating_mode || '').trim().toLowerCase();
      this.$set(setting, 'service_rating_mode', ['off', 'customer_display'].includes(mode) ? mode : 'off');
      if (typeof setting.service_rating_thank_you_title !== 'string') {
        this.$set(setting, 'service_rating_thank_you_title', '');
      }
      if (typeof setting.service_rating_thank_you_content !== 'string') {
        this.$set(setting, 'service_rating_thank_you_content', '');
      }
      if (typeof setting.service_rating_thank_you_image_url !== 'string') {
        this.$set(setting, 'service_rating_thank_you_image_url', '');
      }
      const seconds = Number(setting.service_rating_display_seconds);
      this.$set(setting, 'service_rating_display_seconds', Number.isFinite(seconds) && seconds > 0 ? seconds : 60);
    },
    // Apply from the dialog's local draft: merge only these 4 fields into the
    // real branch setting, Vue-2-safe via $set (none of them are new keys here,
    // but $set keeps this robust if that ever changes). Applying is NOT the
    // same as saving - ownership of any new image URL stays with this page
    // (pendingServiceRatingUpload) until the branch save actually succeeds.
    onServiceRatingApply(draft) {
      const setting = this.form.setting;
      const previousImageUrl = setting.service_rating_thank_you_image_url;
      this.$set(setting, 'service_rating_thank_you_title', draft.service_rating_thank_you_title);
      this.$set(setting, 'service_rating_thank_you_content', draft.service_rating_thank_you_content);
      this.$set(setting, 'service_rating_thank_you_image_url', draft.service_rating_thank_you_image_url);
      this.$set(setting, 'service_rating_display_seconds', draft.service_rating_display_seconds);

      const newImageUrl = draft.service_rating_thank_you_image_url;
      // The previous value was itself an unsaved upload now being replaced or
      // removed by this Apply: it will never be saved, so clean it up now
      // rather than waiting for the page to be left.
      if (previousImageUrl && previousImageUrl === this.pendingServiceRatingUpload && previousImageUrl !== newImageUrl) {
        this.deleteUnsavedServiceRatingImage(previousImageUrl);
      }
      // Pending only while it differs from what the backend last confirmed.
      this.pendingServiceRatingUpload = (newImageUrl && newImageUrl !== this.savedServiceRatingImageUrl)
        ? newImageUrl
        : '';
    },
    // Scoped narrowly to Service Rating: by the time this is needed, the
    // dialog (and its uploadImage instance) is already gone, so this page
    // calls the same existing endpoint directly rather than reusing a ref.
    deleteUnsavedServiceRatingImage(url) {
      if (!url) return;
      const body = {
        token: this.$jwt.sign({ url }, this.$privateKey, { noTimestamp: true }),
      };
      this.$axios.post(`${this.$baseUrl}/branch/delete_unsaved_image`, body).catch(() => {});
    },
    ensurePromptPayAccountSelection() {
      // Read-only for non-owners: auto-selecting would submit a payment change.
      if (!this.canEditPayment) return;
      if (!this.form.setting || this.form.setting.qr_code_payment_mode !== 'promptpay') return;
      const [promptPayAccount] = this.promptPayAccounts;
      if (
        !this.form.setting.qr_code_payment_account_id &&
        this.promptPayAccounts.length === 1 &&
        promptPayAccount._id
      ) {
        this.form.setting.qr_code_payment_account_id = promptPayAccount._id;
      }
    },
    // The server already switched the branch to the tested QR. Mirror ONLY those two
    // fields: in the form (without reloading, so other unsaved edits are kept) and in
    // the shared store (built from the store's own saved copy, so unsaved edits on this
    // page never look saved to other pages, printing or the customer display).
    onQrTemplateActivated(template) {
      this.qrTemplateDialog = false;
      this.$set(this.form.setting, 'qr_code_payment_mode', 'template');
      this.$set(this.form.setting, 'qr_code_payment_template_id', template._id);
      // The server saved the payee text: what the owner typed in the dialog (which starts
      // from the form's own text), or else the shop name printed in the QR when the branch
      // had none. Show it in the form too.
      const prefilled = template.prefilled_label || '';
      if (prefilled) {
        this.$set(this.form.setting, 'qr_code_payment_template_label', prefilled);
      }
      const saved = this.$store.state.list.branchs.find((branch) => branch._id === this.form._id);
      if (!saved) return;
      this.$store.commit('updateBranch', {
        _id: this.form._id,
        setting: {
          ...saved.setting,
          qr_code_payment_mode: 'template',
          qr_code_payment_template_id: template._id,
          // only what the server confirmed, never the unsaved text in the form
          ...(prefilled ? { qr_code_payment_template_label: prefilled } : {}),
        },
      });
    },
    // Draws the QR the shop uses now (no amount) so the owner can see it is working. Only
    // the owner can read it from the server, so staff simply see no preview.
    async loadTemplatePreview() {
      const request = ++this.templatePreviewRequest;
      const setting = this.form.setting || {};
      if (
        !this.isUpdate
        || !this.$store.getters.isBranchOwner
        || setting.qr_code_payment_mode !== 'template'
        || !setting.qr_code_payment_template_id
      ) {
        this.templatePreviewImage = '';
        return;
      }
      try {
        const response = await this.$axios.post(`${this.$baseUrl}/qr_template/preview`, {
          token: this.$jwt.sign(
            { branch_id: String(this.form._id || this.$route.params.id) },
            this.$privateKey,
            { noTimestamp: true }
          ),
        });
        const payload = response.result && response.result.payload;
        const image = payload
          ? await QRCode.toDataURL(payload, { errorCorrectionLevel: 'M', margin: 1, width: 180 })
          : '';
        if (request === this.templatePreviewRequest) this.templatePreviewImage = image;
      } catch (err) {
        if (request === this.templatePreviewRequest) this.templatePreviewImage = '';
      }
    },
    onQrCodePaymentModeChange() {
      if (this.form.setting.qr_code_payment_mode === 'promptpay') {
        this.ensurePromptPayAccountSelection();
      } else {
        this.form.setting.qr_code_payment_account_id = '';
      }
    },
    getQrCodePaymentSettingError() {
      if (this.form.setting.qr_code_payment_mode === 'image') {
        return this.form.qr_code_payment ? '' : 'กรุณาอัปโหลดรูป QR Code ก่อนบันทึก';
      }
      if (this.form.setting.qr_code_payment_mode === 'template') {
        return this.form.setting.qr_code_payment_template_id
          ? ''
          : 'กรุณาตั้งค่า QR Code จากแอพร้านค้าให้เสร็จก่อนบันทึก';
      }
      if (this.form.setting.qr_code_payment_mode !== 'promptpay') return '';
      if (this.promptPayAccounts.length === 0) return 'ยังไม่มีบัญชี PromptPay';
      // A new account receives its _id during the branch save. The backend
      // selects it only when it is the sole PromptPay account.
      if (
        !this.form.setting.qr_code_payment_account_id &&
        this.promptPayAccounts.length === 1
      ) {
        return '';
      }
      if (!this.form.setting.qr_code_payment_account_id) {
        return 'กรุณาเลือกบัญชี PromptPay สำหรับ QR Code';
      }
      if (!this.selectedPromptPayAccount) {
        return 'บัญชี PromptPay ที่เลือกไม่พบ กรุณาเลือกใหม่';
      }
      return '';
    },
    onSubmitAddress(val) {
      if (this.dialogAddressKey == 'split_bill_data.location')
        this.form.split_bill_data.location = val;
      else {
        this.form[this.dialogAddressKey] = val;
        if (this.form.split_bill_data.is_same_as_above)
          this.form.split_bill_data.location = { ...val };
      }
      this.dialogAddress = false;
    },
  },
  watch: {
    templatePreviewKey: { immediate: true, handler() { this.loadTemplatePreview(); } },
  },
  computed: {
    isUpdate() {
      return this.$route.params.id;
    },
    // Changes whenever the preview may need to be drawn again (form loaded, owner flag
    // arrived, template switched on or replaced).
    templatePreviewKey() {
      const setting = this.form.setting || {};
      return [
        this.$store.getters.isBranchOwner,
        setting.qr_code_payment_mode,
        setting.qr_code_payment_template_id,
      ].join('|');
    },
    // A new branch has no id yet, so an uploaded QR can only be set up after it is created.
    availableQrCodePaymentModes() {
      return this.isUpdate
        ? this.qrCodePaymentModes
        : this.qrCodePaymentModes.filter((mode) => mode.value !== 'template');
    },
    // Payment accounts / QR destination are owner-only when editing an existing
    // branch (the backend enforces it). Creating a branch is not restricted.
    // Only for owners of a saved branch that still has no QR set up (no QR shown at all, or
    // the uploaded-QR mode chosen but not finished). Shops using an image or a PromptPay
    // account are not nagged.
    qrNeedsSetup() {
      const setting = this.form.setting || {};
      const noQrYet = setting.qr_code_payment_mode === 'none'
        || (setting.qr_code_payment_mode === 'template' && !setting.qr_code_payment_template_id);
      return this.isUpdate && this.canEditPayment && noQrYet;
    },
    qrPointerVisible() {
      return this.qrNeedsSetup && !this.loading && !this.qrAnchorInView;
    },
    canEditPayment() {
      return !this.isUpdate || this.$store.getters.isBranchOwner;
    },
    promptPayAccounts() {
      return (this.form.bank_account || [])
        .filter((account) => String(account.payment_channel_code || '').trim().toUpperCase() === 'PROMPTPAY')
        .map((account) => ({
          ...account,
          display_name: [account.bank_name, account.account_name, account.account_number]
            .filter(Boolean)
            .join(' · '),
        }));
    },
    selectedPromptPayAccount() {
      return this.promptPayAccounts.find(
        (account) => account._id === this.form.setting.qr_code_payment_account_id
      );
    },
    qrCodePaymentAccountError() {
      return this.getQrCodePaymentSettingError();
    },
  },
};
</script>

<style scoped>
/* Blinking frame around the QR settings while the owner has no QR yet. */
.qr-mode-frame { border: 3px solid transparent; border-radius: 10px; padding: 0 12px 4px; }
.qr-mode-frame--blink { animation: qr-frame-blink 1.2s ease-in-out infinite; }
@keyframes qr-frame-blink {
  0%, 100% { border-color: transparent; box-shadow: none; }
  50% { border-color: #f57c00; box-shadow: 0 0 10px rgba(245, 124, 0, 0.55); }
}
/* Floating pointer that leads an owner down to the QR settings. */
.qr-setup-pointer {
  position: fixed;
  left: 50%;
  bottom: 24px;
  transform: translateX(-50%);
  z-index: 20;
  width: auto !important;
  height: auto !important;
  border-radius: 32px !important;
  padding: 8px 20px !important;
}
.qr-setup-pointer__inner { display: flex; align-items: center; }
.qr-setup-pointer__text { font-size: 1.05rem; font-weight: 700; margin-right: 8px; letter-spacing: 0; }
.qr-setup-pointer__arrow { animation: qr-template-nudge-down 1s ease-in-out infinite; }
.qr-pointer-fade-enter-active, .qr-pointer-fade-leave-active { transition: opacity 0.25s; }
.qr-pointer-fade-enter, .qr-pointer-fade-leave-to { opacity: 0; }
/* Points at the "set up QR" button until the QR is set up. */
.qr-template-arrow {
  animation: qr-template-nudge-right 1s ease-in-out infinite;
}
.qr-template-arrow--down {
  animation-name: qr-template-nudge-down;
}
@keyframes qr-template-nudge-right {
  0%, 100% { transform: translateX(0); }
  50% { transform: translateX(8px); }
}
@keyframes qr-template-nudge-down {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(8px); }
}
@media (prefers-reduced-motion: reduce) {
  .qr-template-arrow, .qr-setup-pointer__arrow { animation: none; }
  .qr-mode-frame--blink { animation: none; border-color: #f57c00; }
}
</style>
